import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ButtonTypesEnum } from '../../enums/button-types.enum';
import { trigger, state, style, transition, animate } from '@angular/animations';


@Component({
    selector: 'agpr-ai-disclaimer',
    templateUrl: './ai-disclaimer.component.html',
    styleUrls: ['./ai-disclaimer.component.scss'],
    animations: [
        trigger('panelContent', [
            state('hidden', style({
                height: '0',
                opacity: 0
            })),
            state('visible', style({
                height: '*',
                opacity: 1
            })),
            transition('visible <=> hidden', animate('500ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    standalone: false
})
export class AiDisclaimerComponent {
    readonly buttonEnum = ButtonTypesEnum;

    @Input() disabled: boolean = false;
    @Input() marginTop: number = 10;
    @Input() confirmButton: boolean = true;

    @Output() apply = new EventEmitter<boolean>();
    @Output() disclaimerValue = new EventEmitter<boolean>();


    @ViewChild('scrollPanel') public scrollPanel: ElementRef;

    agreedDisclaimer: boolean = false;
    disclaimerCollapsed: boolean = false;
    containerClass: string;

    setDisclaimerToggle() {
        this.disclaimerCollapsed = !this.disclaimerCollapsed;
    }

    changeDisclaimer(value: boolean) {
        this.agreedDisclaimer = value;
        if (!this.confirmButton) {
            this.disclaimerValue.emit(this.agreedDisclaimer);
        }
    }

    applyClicked(): void {
        this.apply.next(true);
    }

    onToggleDone(event) {
        event.element.style.display = this.disclaimerCollapsed ? 'none' : 'flex';
        this.containerClass = this.disclaimerCollapsed ? 'agpr-aiDisclaimer--collapsed' : 'agpr-aiDisclaimer--expanded';
    }
}
